import type { ValueOf } from '../util/typeUtils';

export const PARTNER_RESOLVERS = {
    // Scoped server-side to the caller's own pid — no args.
    getMyPartnerContacts: 'getMyPartnerContacts',
    getPartner: 'getPartner',
    getPartnerByDirectPartnerId: 'getPartnerByDirectPartnerId',
    getPartners: 'getPartners',
    getPartnersCount: 'getPartnersCount',
    getPotentialLeadSourcePartners: 'getPotentialLeadSourcePartners',
    getPotentialTipsters: 'getPotentialTipsters',
    // intern resolver (ACL only): partner-chat advisor reachability — saga uses own store-query twin
    hasReachablePartnerAdvisor: 'hasReachablePartnerAdvisor',
} as const;

export type PARTNER_RESOLVER = ValueOf<typeof PARTNER_RESOLVERS>;
